// import loader from './one/loader.js'

export default {
	fill: function(varKey, varValue, question){
		// console.log('question-loader fill()', question)
		return require('./' + question.type + '/loader.js').fill(varKey, varValue, question)
	},
	evaluate: function(question, n){
		// console.log('question-loader evaluate()', question)
		return require('./' + question.type + '/loader.js').evaluate(question, n)
	}
}


// WEBPACK FOOTER //
// ./src/questions/question-loader.js